<script>
import formcombobox from "@/router/views/FormComponet/formcombobox.vue";
import forminput from "@/router/views/FormComponet/forminput.vue"; 
import Loader from "@/components/widgets/loader";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrBirimHarcamaLimit from "@/models/StrBirimHarcamaLimit";
import BirimSecimi from "@/router/views/FormComponet/BirimSecimiAnaBirim.vue";
//import formtreeselect from "@/router/views/FormComponet/formtreeselect.vue";
import { ASYNC_SEARCH } from '@riophae/vue-treeselect'
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import moment from "moment";

const simulateAsyncOperation = fn => {
  setTimeout(fn, 500)
}

export default {
  mixins: [Api, Sabit, StrBirimHarcamaLimit],
  props: ["Id", "AddEdit"],
  data() {
    return {
      FormData: {},
      hesapkodlari:[],
      ucuncu_duzey:false,
      ikinci_duzey: false,
      aktif_arama:true,
      options:null
    };
   
  },
  components: {
    Loader,
    forminput,
    formcombobox,
    BirimSecimi,
   // formtreeselect,
    Treeselect,
  },
  watch: {
    Id() {
      this.FormData = this.Id;
    },
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) { 
        this.FormData.KayitTarihi = moment(new Date()).format("YYYY-MM-DD");
        if (this.AddEdit == "Add") {
          this.Post("StrBirimHarcamaLimit", this.FormData).then((res) => {
            if (res) {
                this.FormData = this.StrBirimHarcamaLimitData
                this.$emit("TableUpdate");
                this.$bvModal.hide("StrBirimHarcamaLimit");
            }
          });
        } else {
          this.Update("StrBirimHarcamaLimit", this.FormData).then((res) => {
            if (res) {
              this.$emit("Update", this.FormData);
              this.FormData = this.StrBirimHarcamaLimitData
              this.$emit("TableUpdate");
              this.$bvModal.hide("StrBirimHarcamaLimit");
            }
          });
        }
      }
    },
    Get() {},

     loadOptions({ action,  callback }) {      
      if (action === ASYNC_SEARCH) {
        
          simulateAsyncOperation(() => {
             this.options = this.hesapkodlari;
          callback(null, this.options)
          
        })
       
      }
    },


    basamak_kontrol(number){

      this.aktif_arama=false;
 
      this.hesapkodlari=[];
      this.options = [];
     
      this.aktif_arama=true;

      if(number == 1 && this.ikinci_duzey == true){
        this.ikinci_duzey = false
      }
      if(number == 2 && this.ucuncu_duzey == true){
        this.ucuncu_duzey = false
      }
   
      

    },
    

    liste_yukle(veri){
      let Page = {
        PageNumber: "1",
        PageSize: "50",
      };

        
    if (veri.length>=1){
      this.hesapkodlari=[];
      this.aktif_arama=true;
      
    let Filter ="";
    if (this.ikinci_duzey){

            if(veri[0]=="0" && veri[2]=="."){
              Filter = "&Basamak=2&KodForLike="+veri;
            } else {
            
            Filter = "&Basamak=2&Aciklama="+veri;
            } 
      }
    if (this.ucuncu_duzey){
            if(veri[0]=="0" && veri[2]=="."){
              Filter = "&Basamak=3&KodForLike="+veri;
            } else {
            
            Filter = "&Basamak=3&Aciklama="+veri;
            } 
      }
     if(this.ucuncu_duzey != true && this.ikinci_duzey != true)
      {
    
            if(veri[0]=="0" && veri[2]=="."){
              Filter = "&Basamak=4&KodForLike="+veri;
            } else {
            
            Filter = "&Basamak=4&Aciklama="+veri;
            } 
      }

    this.ActionsFilterGet({Service:"StrHesapKodlari",Page:Page, Filter:Filter}).then(res => {  
     
      
     
      for(var i=0; i<res.Data.length; i++)
        {       
          this.hesapkodlari.push ({id:res.Data[i].Id,label:res.Data[i].Kod + " - " + res.Data[i].Aciklama})
        }    
    }); 

    } 

    },

  },

};
</script>
<template>
  <Loader>
    <b-modal
      id="StrBirimHarcamaLimit"
      size="lg"
      :title="
        this.AddEdit == 'Edit'
          ? $t('StrBirimHarcamaLimit.AddEdit.FormTitleEdit')
          : $t('StrBirimHarcamaLimit.AddEdit.FormTitleAdd')
      "
      title-class="font-18"
      hide-footer
    >



      <Form @submit.prevent="onSubmit">  
        <div class="row">
          <div class="col-md-6"></div>
          <div class="col-md-6>">
            <div  style="float: right" class="form-check">
              <input id="checkbox-1" class="form-check-input" @click="basamak_kontrol(1)" type="checkbox" name="checkbox-1" v-model="ucuncu_duzey">
              <label for="checkbox-1" class="form-check-label active"> Üçüncü Düzey Kullan </label></div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6"></div>
          <div class="col-md-6>">
            <div  style="float: right" class="form-check">
              <input id="checkbox-1" class="form-check-input" @click="basamak_kontrol(2)" type="checkbox" name="checkbox-1" v-model="ikinci_duzey">
              <label for="checkbox-1" class="form-check-label active"> İkinci Düzey Kullan </label></div>
          </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                  <BirimSecimi
                  :title="FormDataType.Birimid.FieldTitle"
                    :sutun="'0'" 
                    :title_position="'mb-3'"
                    :selected="FormData.Birimid"
                    :labels_lg="'3'"  
                    :v="$v.FormData.Birimid"
                    :multiple="false"
                    :BirimTipId="null"
                    @Secilmis_Idler="FormData.Birimid=$event"
                  />

        
            </div>

          <div class="col-md-6">

           <b-form-group class="mb-3" id="example text"  label="Hesap Kodu" label-for="text">

        
                  <treeselect 
                  ref="treeselect"
                  :clear-search-on-select="true"
                  @search-change="liste_yukle($event)"
                  :async="aktif_arama"
                  :load-options="loadOptions"
                  :multiple="false"   
                  :cacheOptions="false"
                  searchPromptText="Aramak için yazın..."
                  placeholder="Seçiniz..." 
                  v-model="FormData.Hesapkoduid"            
                  />
                  <treeselect-value :value="FormData.Hesapkoduid" />

          </b-form-group>
        
        </div>

        

          <div class="col-md-6">
       <formcombobox
          :FormDataType="FormDataType.Yil"
          :Value="FormData.Yil"
          :v="$v.FormData.Yil"
          @input="FormData.Yil = $event"
        /></div>

          <div class="col-md-6">

        <forminput
          :min="0"
          :step="0.01"
          :FormDataType="FormDataType.Ustlimit"
          :Value="FormData.Ustlimit"
          :v="$v.FormData.Ustlimit"
          @input="FormData.Ustlimit = $event"
        />


       
        </div>
        
        </div>

   <!--
    <table>
      <tr v-for="kodlar in hesapkodlari"  :key="kodlar.id">
        <td>
          <span  > {{ kodlar.label }} </span>
        </td>
      </tr>
    </table>
    --> 
     

        <button class="btn btn-primary" type="submit">
          {{ $t("StrBirimHarcamaLimit.AddEdit.Button") }}
        </button>
      </Form>


    </b-modal>
  </Loader>
</template>
